import React from 'react';
import { Box } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import classes from './StatusCell.module.scss';

const StatusCell = ({ status }) => {
  return (
    <Box className={classes.status}>
      <span className={status === 'active' ? classes.active : classes.inactive}>
        {status === 'active' ? <CheckCircleIcon size='small' /> : <HighlightOffIcon />}
      </span>
      <span className={status === 'active' ? classes.active : classes.inactive}>
        {status === 'active' ? 'Active' : 'Inactive'}
      </span>
    </Box>
  );
};

export default StatusCell;
